import { MessageBar, MessageBarType, Text } from "@fluentui/react";
import React from "react";

import { FailureSeverity, ValidationFailure } from "../../utils";

interface MultipleWarningMessageProps {
    failures: ValidationFailure[];
    severity: FailureSeverity;
}

export const MultipleFailureMessage: React.VFC<MultipleWarningMessageProps> = (props: MultipleWarningMessageProps) => {
    const messageBarType = props.severity === FailureSeverity.Error ? MessageBarType.error : MessageBarType.warning;

    return (
        <>
            {props.failures.map((item) => (
                <>
                    <MessageBar key={item.code} messageBarType={messageBarType}>
                        <>
                            <Text block={false} nowrap={false} variant="smallPlus">
                                {item.message}
                            </Text>
                        </>
                    </MessageBar>
                    <br />
                </>
            ))}
        </>
    );
};
